import { render, staticRenderFns } from "./ModalCreateMaterials.vue?vue&type=template&id=e9f2ae76"
import script from "./ModalCreateMaterials.vue?vue&type=script&lang=js"
export * from "./ModalCreateMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports